import { HelmetDexteel } from "@dexteel/mesf-core";
import { StraightenerTrendDisplay } from "./components/StraightenerTrendDisplay";

export const StraightenerTrendDisplayPage = () => {
	return (
		<>
			<HelmetDexteel title="Straightener Trend Display" />
			<StraightenerTrendDisplay />
		</>
	);
};
